import { DEVICE_FEATURE_TYPES } from '../../../../../server/utils/constants';

const SUPPORTED_FEATURE_TYPES = [
  DEVICE_FEATURE_TYPES.LIGHT.BINARY,
  DEVICE_FEATURE_TYPES.LIGHT.COLOR,
  DEVICE_FEATURE_TYPES.LIGHT.BRIGHTNESS,
  DEVICE_FEATURE_TYPES.LIGHT.TEMPERATURE,
  DEVICE_FEATURE_TYPES.SWITCH.DIMMER,
  DEVICE_FEATURE_TYPES.SWITCH.TARGET_CURRENT,
  DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL,
  DEVICE_FEATURE_TYPES.TELEVISION.VOLUME,
  DEVICE_FEATURE_TYPES.SHUTTER.POSITION,
  DEVICE_FEATURE_TYPES.SHUTTER.STATE,
  DEVICE_FEATURE_TYPES.THERMOSTAT.TARGET_TEMPERATURE,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.MODE,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.TARGET_TEMPERATURE,
  DEVICE_FEATURE_TYPES.FAN.MODE,
  DEVICE_FEATURE_TYPES.FAN.PERCENT,
  DEVICE_FEATURE_TYPES.FAN.SPEED,
  DEVICE_FEATURE_TYPES.FAN.AIRFLOW_DIRECTION,
  DEVICE_FEATURE_TYPES.FAN.ROCK_SETTING,
  DEVICE_FEATURE_TYPES.FAN.WIND_SETTING,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.FAN_SPEED,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.SWING_HORIZONTAL,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.SWING_VERTICAL,
  DEVICE_FEATURE_TYPES.LOCK.BINARY,
  DEVICE_FEATURE_TYPES.LOCK.STATE,
  DEVICE_FEATURE_TYPES.HEATER.PILOT_WIRE_MODE,
  DEVICE_FEATURE_TYPES.SIREN.LMH_VOLUME,
  DEVICE_FEATURE_TYPES.SIREN.MELODY,
  DEVICE_FEATURE_TYPES.DURATION.DECIMAL,
  DEVICE_FEATURE_TYPES.BUTTON.PUSH,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_ON,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.TARGET_CHARGE_LIMIT,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.TARGET_CURRENT,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.CLIMATE_ON,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.TARGET_TEMPERATURE,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_COMMAND.ALARM,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_COMMAND.LOCK
];

export default SUPPORTED_FEATURE_TYPES;
